import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockID, setAttributes } ) {
	const uniqueSelector = `.block-${ blockID }`;
	const {
		containerNormalBackground,
		containerNormalBorder,
		zIndex,
		spacingPadding,
		spacingMargin,
		containerNormalBorderRadius,
		hideOnDesktop,
		hideOnTablet,
		hideOnMobile,
		animation,
		containerNormalRowsGap,
		questionTypography,
		questionPadding,
		questionBackground,
		questionTextColor,
		iconAlignment,
		answerTypography,
		answerPadding,
		answerTextColor,
		iconRadius,
		gapIconQuestion,
		iconBackgroundColor,
		iconBorder,
		iconColor,
		iconPadding,
		iconSize,
		questionBoxShadow,
		containerHoverBackground,
		containerHoverBorder,
		changeBackgroundBorderOnHover,
	} = attributes;

	let CssObj = {
		[ uniqueSelector ]: [
			GenerateCss.backgroundColor( containerNormalBackground ),
			GenerateCss.lengthProp( 'z-index', zIndex ),
			GenerateCss.padding( spacingPadding ),
			GenerateCss.border( containerNormalBorder ),
			GenerateCss.margin( spacingMargin ),
			GenerateCss.borderRadius( containerNormalBorderRadius ),
			GenerateCss.css(
				'display',
				hideOnDesktop ? 'none' : undefined,
				'lg'
			),
			GenerateCss.css(
				'display',
				hideOnTablet ? 'none' : undefined,
				'md'
			),
			GenerateCss.css(
				'display',
				hideOnMobile ? 'none' : undefined,
				'sm'
			),
			GenerateCss.css( 'animation', animation ),
		],
		[ `${ uniqueSelector } .alpha-accordion-item` ]: [
			GenerateCss.lengthProp( 'margin-bottom', containerNormalRowsGap ),
		],
		[ `${ uniqueSelector } .alpha-accordion-item:last-child, ${ uniqueSelector } .block-editor-block-list__layout > .wp-block-alphablock-accordion-item:last-child, ${ uniqueSelector } .block-editor-block-list__layout > .wp-block-alphablock-accordion-item:nth-last-child(2)` ]:
			[
				{
					initial: {
						'margin-bottom': '0px',
						'border-bottom': '1px solid',
					},
				},
			],
		[ `${ uniqueSelector } .alpha-accordion-head` ]: [
			GenerateCss.typography( questionTypography ),
			GenerateCss.padding( questionPadding ),
			GenerateCss.backgroundColor( questionBackground ),
			GenerateCss.textColor( questionTextColor ),
			GenerateCss.css(
				'flex-direction',
				iconAlignment === 'right' ? 'row' : 'row-reverse'
			),
			GenerateCss.lengthProp( 'gap', gapIconQuestion ),
			GenerateCss.boxShadow( questionBoxShadow ),
		],
		[ `${ uniqueSelector } .alpha-accordion-content` ]: [
			GenerateCss.typography( answerTypography ),
			GenerateCss.padding( answerPadding ),
			GenerateCss.textColor( answerTextColor ),
		],
		[ `${ uniqueSelector } .alpha-icon` ]: [
			GenerateCss.borderRadius( iconRadius ),
			GenerateCss.border( iconBorder ),
			GenerateCss.backgroundColor( iconBackgroundColor ),
			GenerateCss.textColor( iconColor ),
			GenerateCss.padding( iconPadding ),
			GenerateCss.lengthProp( 'width', iconSize ),
			GenerateCss.lengthProp( 'height', iconSize ),
		],
	};

	if ( changeBackgroundBorderOnHover ) {
		CssObj[ `${ uniqueSelector }:hover` ] = [
			GenerateCss.backgroundColor( containerHoverBackground ),
			GenerateCss.border( containerHoverBorder ),
		];
	}

	const compiledCss = GenerateCss.CompiledCss( CssObj );
	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
